
import {
  Logger,
  ApiUriConstants,
  AgentSchedule,
  AgentScheduleShift,
  ActivityIntervals,
} from '@nice-ccf/core-sdk';


/**
 * Class to perform schedule service
 */
export class WemScheduleService {
  protected logger: Logger = new Logger('agent-sdk', 'ScheduleService');

  /**
   * Method to get agent schedule
   * @param startDate - start date for fetching schedule
   * @param endDate - end date for fetching schedule
   * @returns - agent Schedule
   * ```
   * @example
   * getSchedule(Tue Aug 16 2022 11:49:38 GMT+0530, Tue Aug 17 2022 11:49:38 GMT+0530)
   * ```
   */
  getSchedule(startDate: Date, endDate: Date): Promise<AgentSchedule[] | any> {
  
    return new Promise((resolve, reject) => {
     
          const schedules: any =[];
          const activitiesOutOfShifts = this.getActivities(
            schedules.activityIntervals
          );
          const shiftsAndActivities = this.getShiftsAndActivities(
            schedules.shifts
          );
          resolve(activitiesOutOfShifts.concat(shiftsAndActivities));
      
      
    });
  }

  /**
   * Method to get shifts and activities
   * @returns - agent schedule
   * ```
   * @example
   * getShiftsAndActivities()
   * ```
   */
  private getShiftsAndActivities(
    shifts: AgentScheduleShift[]
  ): AgentSchedule[] {
    this.logger.info('getShiftsAndActivities', 'Get Shifts and Activities');
    let shiftsAndActivities: AgentSchedule[] = [];
    if (shifts && shifts.length > 0) {
      shifts.forEach((shift: AgentScheduleShift) => {
        const schedule = {} as AgentSchedule;
        schedule.id = shift?.baseActivityCode?.id;
        schedule.title = 'shift';
        schedule.start = new Date(shift?.start);
        schedule.end = new Date(shift?.end);
        schedule.notes = shift?.shiftNotes;
        schedule.backgroundColor =
          shift?.baseActivityCode?.activityCodeCategory?.color;
        shiftsAndActivities.push(schedule);
        shiftsAndActivities = shiftsAndActivities.concat(
          this.getActivities(shift.activityIntervals)
        );
      });
    }
    return shiftsAndActivities;
  }

  /**
   * Method to get activities
   * @returns - activities
   * ```
   * @example
   * getActivities()
   * ```
   */
  private getActivities(
    activityIntervals: ActivityIntervals[]
  ): AgentSchedule[] {
    this.logger.info('getActivities', 'Get Activities');
    const activities: AgentSchedule[] = [];
    if (activityIntervals && activityIntervals.length > 0) {
      activityIntervals.forEach((activity: ActivityIntervals) => {
        const schedule = {} as AgentSchedule;
        schedule.id = activity?.activityCode?.id;
        schedule.title = activity?.activityCode?.title;
        schedule.start = new Date(activity?.start);
        schedule.end = new Date(activity?.end);
        schedule.notes = activity?.activityNotes;
        schedule.backgroundColor =
          activity?.activityCode?.activityCodeCategory?.color;
        activities.push(schedule);
      });
    }
    return activities;
  }
}
